<template>
  <section class="section__1">
    <!-- header -->
    <Header />
    <!-- text -->
    <div class="text__content__container">
      <div class="main__title">
        <h1>
          Breakthrough <br />
          Technology <br />
          for the Brain
        </h1>
      </div>
    </div>
    <div class="mob__img__container">
      <img
        src="https://d33wubrfki0l68.cloudfront.net/images/pages/0fb99213912b0a49657930190a9c5730a8713144/homepage-desktop.png"
        alt="hero-image"
      />
    </div>
    <hr />
    <div class="links__section">
      <div class="grp__one">
        <h3 class="link__item">JOIN THE TEAM</h3>
        <img
          class="right__arrow"
          src="../../assets/right-arrow.png"
          alt="icon"
        />
      </div>
      <div class="grp__two">
        <h3 class="link__item">WATCH THE UPDATE</h3>
        <img
          class="right__arrow"
          src="../../assets/right-arrow.png"
          alt="icon"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Header from "@/components/Header.vue";
export default {
  name: "Section_1",
  components: {
    Header,
  },
};
</script>

<style scoped>
@media only screen and (min-width: 601px) {
  .section__1 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
    padding-bottom: 3.5rem;
    background-color: #b4bdcb;
    background-image: url("https://d33wubrfki0l68.cloudfront.net/images/pages/0fb99213912b0a49657930190a9c5730a8713144/homepage-desktop.png");
    background-position: center;
    background-size: 80%;
    background-repeat: no-repeat;
  }
  .main__title {
    color: white;
    font-size: 40px;
    text-align: start;
    font-family: "Average Sans";
  }
  .mob__img__container {
    display: none;
  }
  hr {
    color: white;
    border-top: 2px solid white;
    width: 37%;
    margin: 0;
  }
  .right__arrow {
    width: 15px;
    height: 20px;
    filter: invert(100);
    font-family: sans-serif;
    cursor: pointer;
  }
  .links__section {
    display: flex;
    flex-direction: row;
  }
  .link__item {
    margin-right: 0.5rem;
    color: white;
    font-family: "Barlow", sans-serif;
    cursor: pointer;
  }
  .grp__one {
    display: flex;
    align-items: center;
    margin-right: 2rem;
  }
  .grp__two {
    display: flex;
    align-items: center;
    margin-right: 2rem;
  }
  .text__content__container {
    margin-bottom: 8rem;
  }
  .main__title > h1 {
    margin-top: 0;
  }
}
/* Mobile responsive code */
@media only screen and (max-width: 600px) {
  h3 {
    margin: 0;
  }
  .section__1 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 3.5rem;
    background-color: #b4bdcb;
    /* background-image: url("https://d33wubrfki0l68.cloudfront.net/images/pages/0fb99213912b0a49657930190a9c5730a8713144/homepage-desktop.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat; */
  }
  .main__title {
    color: white;
    font-size: 30px;
    text-align: start;
    font-family: "Average Sans";
    margin-top: 3.5rem;
    margin-bottom: 20rem;
  }
  .mob__img__container > img {
    /* display: block; */
    width: 37rem;
    height: auto;
  }
  .mob__img__container {
    text-align: center;
    position: absolute;
    top: 21rem;
    left: -13.5rem;
  }
  hr {
    color: white;
    border-top: 2px solid white;
    width: 80%;
    margin: 0;
  }
  .right__arrow {
    width: 15px;
    height: 20px;
    filter: invert(100);
    font-family: sans-serif;
    cursor: pointer;
  }
  .links__section {
    display: flex;
    flex-direction: column;
  }
  .link__item {
    margin-right: 0.5rem;
    color: white;
    font-family: "Barlow", sans-serif;
    cursor: pointer;
  }
  .grp__one {
    display: flex;
    align-items: center;
    margin-top: 1rem;
    /* margin-right: 2rem; */
  }
  .grp__two {
    display: flex;
    align-items: center;
    margin-top: 1rem;
    margin-right: 2rem;
  }
  .text__content__container {
    margin-bottom: 8rem;
  }
  .main__title > h1 {
    margin-top: 0;
  }
}
</style>
